var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 398.66 398.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Degradado_sin_nombre_24-2);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fecb2a;\n      }\n\n      .cls-3 {\n        fill: url(#Degradado_sin_nombre_24-3);\n      }\n\n      .cls-4 {\n        fill: url(#Degradado_sin_nombre_24);\n      }\n\n      .cls-5 {\n        fill: #21a759;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_24",
    "data-name": "Degradado sin nombre 24",
    x1: 145.73,
    y1: 100.46,
    x2: 299.57,
    y2: 264.42,
    gradientTransform: "translate(-56.2 79.96) rotate(-20)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#fff",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#fff",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#fff",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#fff",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#fff",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#fff",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_24-2",
    "data-name": "Degradado sin nombre 24",
    x1: 127.22,
    y1: 117.97,
    x2: 281.05,
    y2: 281.93,
    xlinkHref: "#Degradado_sin_nombre_24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_24-3",
    "data-name": "Degradado sin nombre 24",
    x1: 207.22,
    y1: 207.73,
    x2: 755.47,
    y2: 792.08,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#Degradado_sin_nombre_24"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_7",
    "data-name": "Capa 7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.22,302.72c-25.63,9.33-38.89,37.76-29.56,63.39,9.33,25.63,37.76,38.89,63.39,29.56,25.63-9.33,38.89-37.76,29.56-63.39-9.33-25.63-37.76-38.89-63.39-29.56ZM81.32,360.7c-6.34,2.31-13.38-.97-15.69-7.32-2.31-6.34.97-13.38,7.32-15.69,6.34-2.31,13.38.97,15.69,7.32,2.31,6.34-.97,13.38-7.32,15.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M259.58,54.02c-1.03-13.88,2.69-27.79,10.51-39.36l-110.61,40.26-45.3,97.17-63.18,23-44.33-20.67,22.84,62.76,108.21-39.38,44.6-95.64,77.27-28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M139.08,344.64c1.03,13.88-2.69,27.79-10.51,39.36l110.61-40.26,45.3-97.17,63.18-23,44.33,20.67-22.84-62.75-108.21,39.38-44.6,95.64-77.27,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M271.14,85.79l-63.88,23.25-44.59,95.63-121.6,44.26,15.21,41.78c6.64-2.37,13.53-3.59,20.48-3.62,20.09-.13,39.05,9.5,50.77,25.78l63.89-23.25,44.59-95.63,121.6-44.26-15.21-41.78c-6.64,2.37-13.52,3.58-20.48,3.62-20.09.13-39.05-9.5-50.77-25.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M304.61,2.99c-25.63,9.33-38.89,37.76-29.56,63.39,9.33,25.63,37.76,38.89,63.39,29.56,25.63-9.33,38.89-37.76,29.56-63.39-9.33-25.63-37.76-38.89-63.39-29.56ZM325.72,60.96c-6.34,2.31-13.38-.97-15.69-7.32-2.31-6.34.97-13.38,7.32-15.69,6.34-2.31,13.38.97,15.69,7.32,2.31,6.34-.97,13.38-7.32,15.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50.98,175.52l-43.6-20.33,22.37,61.46,107.67-39.19,44.6-95.64,48.59-17.68c-5.7-9.82-12.69-18.94-20.88-27.07l-49.94,18.18-45.3,97.17-63.49,23.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.07,185.13c13.51-28.97,15.48-60.35,7.82-88.99l-36.34,13.23-44.59,95.63-108.38,39.45c2.52,1.38,5.09,2.7,7.73,3.93,65.45,30.52,143.24,2.2,173.76-63.24Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 398.66,
    height: 398.66
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a3530dd17371c793d3326caa8a9fccf9.svg";
export { ForwardRef as ReactComponent };